import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import * as Styles from './StaffNotes.styles';
import LoadingImage from 'assets/svg/loading.svg';
import CustomModal from 'components/custom-modal/CustomModal';
import { ErrorMessage, Form, Formik } from 'formik';
import { initialValuesOfStaffNotes, validationSchemaOfStaffNotes } from 'components/support/utils';
import RadioButton from 'components/radio-button/RadioButton';
import Input from 'components/input';
import ReactDatePicker from 'react-datepicker';
import CustomButton from 'components/common/custom-button/custom-button';
import moment from 'moment';
import StaffDropdown from 'components/support/components/StaffDropdown';
import { Link } from 'react-router-dom';
import { H5, H6, P } from 'utils/resuable-css';
import { Base64 } from 'js-base64';
import { useTranslation } from 'react-i18next';

const StaffNotes = (props) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(new Date());
  const [datetime, setDateTime] = useState(moment(startDate).format('MMMM DD, YYYY hh:mm A'));
  const {
    addStaffNotesLoading,
    closeStaffNoteModal,
    isOpenStaffModal,
    handleAddStaffNotes,
    openStaffNotes,
    closedStaffNotes,
    loading,
    isFetching,
    isOpenStaffNotes,
    handleStaffNotes,
    handleCloaseStaffNotes,
    loadingCloseStaff,
  } = props;
  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);
    setDateTime(moment(startDate).format('MMMM DD, YYYY hh:mm A'));
    return currentDate.getTime() < selectedDate.getTime();
  };
  return (
    <Styles.DraggableContainer id="alertParent">
      <div>
        <div id="alertChild">
          <Styles.TopBar>
            <Styles.Left>
              <Icon name="user" color="black" />
              <H5>{t('dashboard.string5')} </H5>
              <P className="count">
                {t('dashboard.string2', {
                  count: loading ? 0 : isOpenStaffNotes ? openStaffNotes?.count : closedStaffNotes?.count,
                })}
              </P>
              {isFetching && <img src={LoadingImage} height={28} alt="loading" />}
            </Styles.Left>
            <Styles.Right>
              <Icon name="expand" />
            </Styles.Right>
          </Styles.TopBar>
        </div>
        <Styles.Content>
          {isOpenStaffNotes
            ? openStaffNotes?.staff_notes.map((val, i) => (
                <Styles.NotificationContainer style={{ pointerEvents: loadingCloseStaff ? 'none' : 'auto' }} key={i}>
                  <Styles.Alert>
                    <H6> {Base64.decode(val.note)}</H6>
                    <P style={{ color: 'gray' }}>
                      {t('dashboard.string6', {
                        date: val.date_local_format_mdy,
                        date_ago: val.date_ago_en,
                      })}
                    </P>
                    {val.scheduled_date !== '0000-00-00 00:00:00' && (
                      <P style={{ color: 'gray' }}>
                        {t('dashboard.string7', {
                          date: val.scheduled_date_local_format_mdy,
                        })}
                      </P>
                    )}
                    {val.ticket_reference !== '' && (
                      <Link to={`/admin/tickets/${val.ticket_reference}`}>
                        <P style={{ textDecoration: 'underline' }}>
                          {t('dashboard.string8', {
                            date: val.ticket_reference,
                          })}
                        </P>
                      </Link>
                    )}
                  </Styles.Alert>
                  {!val?.ticket_reference && (
                    <StaffDropdown
                      loadingCloseStaff={loadingCloseStaff}
                      val={val}
                      handleCloaseStaffNotes={(id) => handleCloaseStaffNotes(id)}
                    />
                  )}
                </Styles.NotificationContainer>
              ))
            : closedStaffNotes?.staff_notes?.map((val, i) => (
                <Styles.NotificationContainer key={i}>
                  <Styles.Alert>
                    <H6>{Base64.decode(val.note)}</H6>
                    <P style={{ color: 'gray' }}>
                      {t('dashboard.string6', {
                        date: val.date_local_format_mdy,
                        date_ago: val.date_ago_en,
                      })}
                    </P>
                    {val.scheduled_date !== '0000-00-00 00:00:00' && (
                      <P style={{ color: 'gray' }}>
                        {t('dashboard.string7', {
                          date: val.scheduled_date_local_format_mdy,
                        })}
                      </P>
                    )}
                    {val?.ticket_reference !== '' && (
                      <Link to={`/admin/tickets/${val?.ticket_reference}`}>
                        <P style={{ textDecoration: 'underline' }}>
                          {t('dashboard.string8', {
                            date: val.ticket_reference,
                          })}
                        </P>
                      </Link>
                    )}
                  </Styles.Alert>
                </Styles.NotificationContainer>
              ))}
        </Styles.Content>
      </div>
      <Styles.TradeContainer>
        <P onClick={() => closeStaffNoteModal()}>{t('dashboard.string9')}</P>
        <P className="space">|</P>
        <P onClick={() => handleStaffNotes(true)} style={{ color: isOpenStaffNotes ? '#ff904f' : '#666666' }}>
          {t('dashboard.string10')}
        </P>
        <P className="space">|</P>
        <P style={{ color: isOpenStaffNotes ? '#666666' : '#ff904f' }} onClick={() => handleStaffNotes(false)}>
          {t('dashboard.string11')}
        </P>
      </Styles.TradeContainer>
      <CustomModal heading="dashboard.string12" open={isOpenStaffModal} onClose={() => closeStaffNoteModal()}>
        <Formik
          initialValues={initialValuesOfStaffNotes}
          validationSchema={validationSchemaOfStaffNotes}
          onSubmit={(values) => handleAddStaffNotes(values.staff_note, values.date, datetime)}
        >
          {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => (
            <Form>
              <Styles.ModalContainer>
                <Styles.SelectDateTime>
                  <H5>{t('dashboard.string13')}</H5>
                  <Styles.DateTime onClick={() => setFieldValue('date', 'now')}>
                    <RadioButton
                      id="now"
                      setCheckedValue={(value) => setFieldValue(value)}
                      checkbox={values.date}
                      onClick={() => setFieldValue('date', 'now')}
                    />
                    <H6>{t('dashboard.string14')}</H6>
                  </Styles.DateTime>
                  <Styles.DateTime style={{ display: 'flex' }}>
                    <RadioButton
                      id="later"
                      setCheckedValue={(value) => setFieldValue(value)}
                      checkbox={values.date}
                      onClick={() => setFieldValue('date', 'later')}
                    />
                    <div>
                      <H6 onClick={() => setFieldValue('date', 'later')}>{t('dashboard.string15')}</H6>
                      <Input
                        type="text"
                        name={'datetime'}
                        value={datetime}
                        placeholder="DateTime"
                        isFormIk={false}
                        styling={{ width: '21.3em', marginTop: '-1em' }}
                      />
                      <ReactDatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        showTimeSelect
                        filterTime={filterPassedTime}
                        dateFormat="MMMM d, yyyy h:mm aa"
                        minDate={new Date()}
                        inline
                      />
                    </div>
                  </Styles.DateTime>
                </Styles.SelectDateTime>
                <ErrorMessage name={'staff_note'} render={(msg) => <span className="error_messageSty">{msg}</span>} />
                <Styles.TextArea>
                  <textarea
                    name={'staff_note'}
                    value={values['staff_note']}
                    placeholder={t('dashboard.string16')}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors['staff_note']}
                    touched={touched['staff_note']}
                    rows="4"
                  />
                </Styles.TextArea>
                <CustomButton
                  type="submit"
                  title="dashboard.string17"
                  buttonStyles={{
                    float: 'right',
                  }}
                  isLoading={addStaffNotesLoading}
                />
              </Styles.ModalContainer>
            </Form>
          )}
        </Formik>
      </CustomModal>
    </Styles.DraggableContainer>
  );
};
export default StaffNotes;
